import { render, staticRenderFns } from "./ProcessTime.vue?vue&type=template&id=89024dd4&scoped=true&"
import script from "./ProcessTime.vue?vue&type=script&lang=ts&"
export * from "./ProcessTime.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessTime.vue?vue&type=style&index=0&id=89024dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89024dd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VDataTable,VIcon,VPagination,VSpacer})
